import DashboardStats from "./DashboardStats";
import WorkflowPipeline from "./WorkflowPipeline";
import StatusChart from "./StatusChart";
import RecentDossiers from "./RecentDossiers";
import DashboardAlerts from "./DashboardAlerts";

import "./RoleDashboard.css";

export default function CoachDashboard({ dashboard }) {
  return (
    <div className="role-dashboard">
      <DashboardStats type="coach" stats={dashboard.stats} />

      <div className="role-dashboard__grid role-dashboard__grid--two">
        <WorkflowPipeline items={dashboard.workflow_pipeline} />
        <StatusChart items={dashboard.status_stats} />
      </div>

      <div className="role-dashboard__grid role-dashboard__grid--two">
        <DashboardAlerts alerts={dashboard.alerts} />
        <RecentDossiers dossiers={dashboard.recent_dossiers} />
      </div>
    </div>
  );
}
